import React from "react";

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-blue-50/40 to-white px-4 py-12 sm:px-6 sm:py-16">
      <article className="mx-auto max-w-4xl rounded-3xl border border-slate-200 bg-white p-6 text-slate-700 shadow-[0_18px_60px_rgba(15,23,42,0.07)] sm:p-10 [&_h2]:mt-8 [&_h2]:text-slate-950">
      <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-blue-700">Our story</p>
      <h1 className="text-3xl font-black tracking-tight mb-6 text-slate-950 sm:text-4xl">
        About JobZam®
      </h1>

      {/* Business Description */}
      <h2 className="text-2xl font-semibold mb-3">What is JobZam?</h2>
      <p className="text-lg leading-relaxed mb-6">
        JobZam® is an AI-powered career platform that helps jobseekers optimise
        their resumes, improve Applicant Tracking System (ATS) match scores,
        and increase interview success. The platform analyses resumes against
        job descriptions and provides practical, actionable insights to help
        candidates align with recruiter expectations.
      </p>

      {/* Problem */}
      <h2 className="text-2xl font-semibold mb-3">The Problem We Solve</h2>
      <p className="text-lg leading-relaxed mb-6">
        Modern hiring processes rely heavily on Applicant Tracking Systems (ATS).
        Many qualified candidates are rejected because their resumes do not match
        job description keywords or formatting requirements. JobZam bridges this
        gap by helping users understand what employers are really looking for
        and adjust their applications accordingly.
      </p>

      {/* Product Offering */}
      <h2 className="text-2xl font-semibold mb-3">What JobZam Offers</h2>
      <ul className="list-disc pl-6 text-lg leading-relaxed mb-6 space-y-2">
        <li>Resume-to-job description analysis</li>
        <li>ATS compatibility scoring</li>
        <li>AI-optimised resume rewriting</li>
        <li>Tailored cover letter generation</li>
        <li>Interview preparation based on resume and role</li>
      </ul>

      {/* How It Works */}
      <h2 className="text-2xl font-semibold mb-3">How It Works</h2>
      <ol className="list-decimal pl-6 text-lg leading-relaxed mb-6 space-y-2">
        <li>Upload your resume</li>
        <li>Paste a job description</li>
        <li>Receive an ATS match score and improvement insights</li>
        <li>Generate an optimised resume and cover letter</li>
        <li>Download and apply confidently</li>
      </ol>

      {/* Product Status */}
      <h2 className="text-2xl font-semibold mb-3">Product Status</h2>
      <p className="text-lg leading-relaxed mb-6">
        JobZam® is live and publicly available at <strong>jobzam.co</strong>.
        The platform is currently used by over <strong>12,500+ jobseekers</strong>
        across 20+ countries. Users can access 3 free resume optimisations
        before upgrading to premium plans.
      </p>

      {/* Company & Founder */}
      <h2 className="text-2xl font-semibold mb-3">Company & Founder</h2>
      <p className="text-lg leading-relaxed mb-6">
        JobZam® is developed and operated by <strong>Power Data Tech Ltd</strong>,
        a UK-registered company. It was founded by <strong>Shiv Venna</strong>, a UK-based
        software engineer and entrepreneur focused on building digital-native
        tools that make hiring more transparent and accessible for jobseekers globally.
      </p>

      {/* Product Demo */}
      <h2 className="text-2xl font-semibold mb-3">Product Demo</h2>
      <p className="text-lg leading-relaxed mb-4">
        Watch a short demonstration of how JobZam’s AI-powered resume analysis
        and optimisation tools work in real time.
      </p>

      <div className="mb-10">
        <iframe
          className="aspect-video w-full rounded-2xl border border-slate-200"
          src="https://www.youtube.com/embed/1_w86olANTY"
          title="JobZam Demo"
          loading="lazy"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Feedback */}
      <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5">
        <p className="text-lg text-blue-700 font-medium mb-2">
          We’d love your feedback
        </p>
        <p className="text-base text-gray-700">
          Help us improve JobZam® by filling out our quick form —
          your input helps shape future updates.
        </p>
        <a
          href="https://forms.gle/hf9egFiokcuC1ScV6"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 items-center justify-center mt-3 px-5 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition focus:outline-none focus:ring-4 focus:ring-blue-200"
        >
          Share Your Feedback
        </a>
      </div>

      <p className="text-xs text-gray-500 mt-8">
        JobZam® is a registered UK trademark (UK00004249682).
      </p>
      </article>
    </div>
  );
};

export default About;
